import moment from 'moment';

/**
 * Format a date to a Month day, year date format in UTC timezone
 * ex: January 1, 2021
 *
 * @param {date} date
 *
 * @returns {string} - formatted date.
 */
const formattedDateMonthDayYearUTC = (date) => {
  if (!date) return '-';
  return moment.utc(date, 'YYYY-MM-DD', 'hh:mm:ss').format('MMMM D, YYYY');
};

export default formattedDateMonthDayYearUTC;
